module.exports = __webpack_public_path__ + "img/16_73.f6dc1c8a.png";